<template>
  <a v-if="menu.__typename === 'artists' && path === '/artwork/artist'" :href="`#${menu.slug}`">
    {{ menu.name }}
  </a>
  <router-link
    v-else-if="menu.__typename === 'artists' && path !== '/artwork/artist'"
    :to="`/artwork/artist#${menu.slug}`"
  >
    {{ menu.name }}
  </router-link>
  <router-link
    v-else-if="menu.__typename !== 'artists'"
    :to="
      router.resolve({
        name: 'ArtworkTerm',
        params: {
          subtype: menu.__typename.toLowerCase(),
          search: menu.slug,
        },
      }).path
    "
  >
    {{ prepareMenuName(menu.name) }}
  </router-link>
</template>

<script setup lang="ts">
import { Filters } from '@/types/artwork.interface.ts';
import { useRouter } from 'vue-router';

defineProps<{
  menu: Filters;
  path: string;
}>();

const router = useRouter();

function prepareMenuName(name: string): string {
  return name
    .split(' ')
    .map((word) =>
      word === 'on' || word === 'of' ? word : word[0].toUpperCase() + word.substring(1),
    )
    .join(' ');
}
</script>
